// Pure gateway-binding factory shared by hooks/useAPI (main app) and auth/api (login bundle).
// It must import neither react-redux nor react-router — the login first-paint chunk depends on
// staying free of both (guarded by check:bundle).

const GATEWAY_METHODS = [
  'getPrecached',
  'get',
  'post',
  'patch',
  'delete',
  'deleteWithKeepalive',
  'patchWithKeepalive',
];

// Wraps every gateway method: injects the Authorization header and throws on HTTP errors,
// letting `onError` run a side effect (e.g. navigate) first.
export const makePatchedGateway = (gateway, { authorization = null, onError } = {}) =>
  Object.fromEntries(
    GATEWAY_METHODS.map((methodName) => [
      methodName,
      async (requestPath, requestParams = {}, requestHeaders = {}, options = {}) => {
        const { data, status } = await gateway[methodName](requestPath, requestParams, {
          Authorization: authorization,
          ...requestHeaders,
        });

        if (status >= 400) {
          onError?.(status, options);
          throw new Error(`${methodName.toUpperCase()} ${requestPath} ${status}`);
        }

        return data;
      },
    ])
  );

// Binds one api/* module's methods (which use `this.get/post/...`) to a patched gateway.
export const bindAPI = (api, patchedGateway) =>
  Object.fromEntries(
    Object.entries(api).map(([methodName, method]) => [methodName, method.bind(patchedGateway)])
  );
